<template>
<v-app>

    <v-fade-transition mode="out-in">
        <component :is="getDynamicComponent()" />
    </v-fade-transition>


</v-app>
</template>
<script>
import AppContainer from './views/AppContainer.vue';
import AuthContainer from '@imemento/spa-helpers/src/views/auth/AuthContainer.vue';
import Healthy from '@imemento/spa-helpers/src/views/healthy/Healthy.vue';


import storage from './storage';

export default {
    components: {
        'im-healthy-container': Healthy,
        'im-app-container': AppContainer,
        'im-auth-container': AuthContainer,
    },

    // this will make sure view app is refreshed
    // if the user logged-in/logged-out on another spa
    mounted() {
        window.onfocus = async () => {
            let token = await storage.getToken();
            let roles = await storage.getRoles();

            if((!token && !roles) && this.$route.meta.private_route) {
                this.$router.push('/authentication/login')
            }

            if(token && roles && !this.$route.meta.private_route) {
                this.$router.push('/')
            }
        };

    },
    created() {
        this.$moment.locale('ro');
    },

    data() {
        return {
            snackbar: false,
            timeout: 2500
        }
    },

    watch: {

    },

    computed: {},

    methods: {
        getDynamicComponent() {
            if(this.$route.path === '/healthy')
                return 'im-healthy-container';

            if(this.$route.meta.private_route === false)
                return 'im-auth-container';

            if(this.$route.meta.private_route === true)
                return 'im-app-container';

            if(this.$route.meta.private_route === undefined)
                return '';
        }
    }
}
</script>
